export const customLayoutKeys = {
    default: 'default',
    mobileService: 'mobileService',
}
